import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { OrderSection } from 'modules/order/common/components';
import { Field } from 'modules/order/common/forms/orderForm';

import { useAdditionalParametersSection } from './useAdditionalParametersSection';

export const AdditionalParametersSection = () => {
  const { t } = useTranslation();

  const { isRequired } = useAdditionalParametersSection();

  const isEditable = useIsFormEditable();

  return (
    <OrderSection
      fields={[
        <Field.DatePicker
          disableFuture
          fullWidth
          disabled={!isEditable ? false : !isRequired}
          label={t(
            'order.sections.additionalParametersSection.fields.transactionDate.label'
          )}
          name="additionalParameters.transactionDate"
          placeholder={
            isRequired
              ? t(
                  'order.sections.additionalParametersSection.fields.transactionDate.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequired}
        />,
        <Field.DatePicker
          fullWidth
          disabled={!isEditable ? false : !isRequired}
          disableFuture={false}
          label={t(
            'order.sections.additionalParametersSection.fields.settlementDate.label'
          )}
          minDate={new Date()}
          name="additionalParameters.settlementDate"
          placeholder={
            isRequired
              ? t(
                  'order.sections.additionalParametersSection.fields.settlementDate.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequired}
        />,
      ]}
      title={t('order.sections.additionalParametersSection.title')}
    />
  );
};
